import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
export function TraceInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    if (!(request.url.includes('realms') || request.url.includes('directus') || request.url.includes('assets/extra'))) {
        const traceId = uuidv4();
        const clone = request.clone({
            headers: request.headers.append('X-Request-Id', traceId),
        });
        return next(clone);
    }
    return next(request);
}
